import * as monaco from 'monaco-editor';

// Configure Monaco's web workers using webpack 5's native worker bundling.
// This replaces monaco-editor-webpack-plugin, which is incompatible with
// monaco-editor >= 0.55 (its package.json `exports` field disabled the
// extension-less module resolution the plugin relied on).
// Paths use the package exports mapping (`./*.js` → `./esm/vs/*.js`),
// so the `esm/vs/` prefix must be omitted from import specifiers.
self.MonacoEnvironment = {
  getWorker(_workerId, label) {
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new Worker(
        new URL('monaco-editor/language/html/html.worker.js', import.meta.url)
      );
    }
    return new Worker(
      new URL('monaco-editor/editor/editor.worker.js', import.meta.url)
    );
  }
};

const CONFIG = {
  fontSize: 14,
  lineNumbers: 'off',
  minimap: {
    enabled: false
  },
  language: 'html',
  automaticLayout: true,
  tabSize: 2
};

export const createEditor = (panel, changeHandler) => {
  //Editor theme change
  var element = document.documentElement;
  monaco.editor.defineTheme('dark', {
    base: 'vs-dark',
    inherit: true,
    rules: [],
    colors: {}
  });
  var observer = new MutationObserver(function () {
    monaco.editor.setTheme(element.getAttribute('flare-mode'));
  });
  observer.observe(element, {
    attributes: true,
    attributeFilter: ['flare-mode']
  });

  const editor = monaco.editor.create(panel, CONFIG);
  const model = editor.getModel();

  //Set initial mode
  monaco.editor.setTheme(element.getAttribute('flare-mode'));

  model.onDidChangeContent(() => changeHandler(model.getValue()));
  return content => {
    model.setValue(content);
  };
};
